module.exports = __webpack_public_path__ + "static/media/easylab.936ac514.svg";